var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandListAll = function SvgExpandListAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.472 6.972 12.5 4.943l2.028 2.029.944-.944-2.5-2.5-.472-.47-.472.47-2.5 2.5zM10.472 9.028l2.028 2.029 2.028-2.029.944.944-2.5 2.5-.472.47-.472-.47-2.5-2.5zM7 3.833v1.334H1V3.833zM7 7.333v1.334H1V7.333zM7 10.833v1.334H1v-1.334z"
  })));
};
export default SvgExpandListAll;